import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ConfirmationService, MessageService } from 'primeng/api';

import { AppPrimengModule } from 'app/shared/app-primeng';
import { CreditLimitComponent } from './credit-limit.component';

registerLocaleData(localePt);

@NgModule({
	declarations: [CreditLimitComponent],
	imports: [AppPrimengModule, FormsModule, CommonModule],
	providers: [
		ConfirmationService,
		MessageService,
		DatePipe,
		{ provide: LOCALE_ID, useValue: 'pt-BR' },
	],
})
export class CreditLimitModule {}
